"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HodOnboardingStepTypes = void 0;
const CommonOnboardingStepTypes_1 = require("../../common/domain/CommonOnboardingStepTypes");
const HodOnboardingStepId_1 = require("./HodOnboardingStepId");
const MatchingStep_1 = require("./matching/MatchingStep");
const HodGetToKnowUsStep_1 = require("./getToKnowUs/HodGetToKnowUsStep");
const AdministrativeDocumentsStep_1 = require("./administrative/AdministrativeDocumentsStep");
const MeetingStep_1 = require("./meeting/MeetingStep");
const keyedRecord_1 = require("../../infrastructure/keyedRecord");
exports.HodOnboardingStepTypes = Object.assign({}, CommonOnboardingStepTypes_1.CommonOnboardingStepTypes, (0, keyedRecord_1.keyedRecord)()({
    [HodOnboardingStepId_1.HodOnboardingStepId.HOD_MATCHING]: MatchingStep_1.MatchingStep,
    [HodOnboardingStepId_1.HodOnboardingStepId.HOD_GET_TO_KNOW_US]: HodGetToKnowUsStep_1.HodGetToKnowUsStep,
    [HodOnboardingStepId_1.HodOnboardingStepId.HOD_ADMINISTRATIVE_DOCS]: AdministrativeDocumentsStep_1.AdministrativeDocumentsStep,
    [HodOnboardingStepId_1.HodOnboardingStepId.HOD_MEETING]: MeetingStep_1.MeetingStep,
}));
//# sourceMappingURL=HodOnboardingStepTypes.js.map